import { Form } from "react-bootstrap";
import { z } from "zod/v4";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { useForm } from "../common/form/useForm";
import { ExtraForm } from "../common/pure/ExtraFormGroup";
import { Button } from "../components/Button";
import { useBranding } from "../hooks/use-app-metadata";
import { AuthPage } from "../layout/AuthLayout";
import { useAuth } from "./useAuth";

const Schema = z.object({
	email: z
		.email({ error: "Email is not valid." })
		.nonempty({ error: "Email field is required." }),
});

export const PageForgotPassword = () => {
	const branding = useBranding();
	const { requestReset } = useAuth();
	const form = useForm({
		validationSchema: toFormikValidationSchema(Schema),
		initialValues: {
			email: "",
		},
		onSubmit: (values) => requestReset.mutateAsync(values),
	});

	return (
		<AuthPage title="Forgot Password">
			<Form className="auth-form" onSubmit={form.handleSubmit}>
				<h1 className="mb-4">Forgot Password?</h1>
				<p>
					Enter the email address you used when you joined and we’ll send you
					instructions to reset your password.
				</p>

				<ExtraForm.Group label="Email">
					<ExtraForm.Control
						placeholder="john.doe@example.com"
						type="email"
						{...form.getFieldProps("email")}
						{...form.getFieldState("email")}
					/>
				</ExtraForm.Group>

				<Button full className="my-3" loading={form.isSubmitting} type="submit">
					Send reset instructions
				</Button>
				<footer>
					{branding.footerText ??
						`© ${new Date().getFullYear()} ${branding.appName}. All rights reserved`}
				</footer>
			</Form>
		</AuthPage>
	);
};
